import { ReactNode } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import logger from '@/utils/logger';

interface RecaptchaProviderProps {
  children: ReactNode;
}

/**
 * Provides Google reCAPTCHA v3 integration for the application
 * Wraps the application with the reCAPTCHA provider
 */
const RecaptchaProvider = ({ children }: RecaptchaProviderProps) => {
  // Check both formats of the site key (with VITE_ prefix for local and without for production)
  const recaptchaSiteKey = import.meta.env.RECAPTCHA_SITE_KEY || import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  
  if (!recaptchaSiteKey) {
    logger.warn('reCAPTCHA site key is missing. Protected API calls may fail.');
    // If no key is available, just render children
    return <>{children}</>;
  }
  
  logger.info('Initializing reCAPTCHA with site key', { 
    keyPrefix: recaptchaSiteKey.substring(0, 6) + '...' 
  });
  
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'body',
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default RecaptchaProvider; 